 
  <div class="tabs-container">
    <div class="custom-tab-group card p-10">
      <div class="tab-button" 
           [class.active]="selectedTypeTabName === 'createcalendar'" 
           (click)="selectTab('createcalendar')">
        <span class="material-icons">calendar_today</span>
       My Training calendar
      </div>
      <div class="tab-button" 
           [class.active]="selectedTypeTabName === 'employeeapproval'" 
           (click)="selectTab('employeeapproval')">
        <span class="material-icons">how_to_reg</span>
        Team Training Calendar
      </div>
    </div>
    
    
    
    <div class="card  createcalendar">

      <!--My Training calendar -->
       
      <div class="p-10 m-20 createcalendar"  *ngIf="selectedTypeTabName=='createcalendar'">

        <div class="cardBox mb-20">
          <ion-row class="ion-align-items-center ion-justify-content-start ml-20 pt-20">
  
            <!-- Year Select -->
            <ion-col size="12" size-sm="3" class=" ml-sm-20 mt-sm-20">
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                            (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                  <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                    {{ sharedService.transformYearToFyFormat(item.year) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>
          
            <!-- Program Select -->
            <ion-col size="12" size-sm="3" class=" ml-sm-20 mt-sm-20">
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select Type" >
                  <mat-option *ngFor="let program of programList" [value]="program">
                    {{ program }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>
          </ion-row>
          
          <hr style="border: none; height: 1px; background-color: #cccccc8f;" />

          
      <ion-row class="ion-align-items-center ion-justify-content-between ml-10">
        <ion-col size="12" size-lg="9">
          <ion-row class="ion-align-items-center">
            <!-- Search -->
            <ion-col size="12" size-sm="4" >
              <mat-form-field class="mat-height40 mat-input-style w-100">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
              </mat-form-field>
            </ion-col>
          </ion-row>
        </ion-col>

        <ion-col size="12" size-lg="3" >
          <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">    
            <label>
              <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
              <mat-form-field class="w70px mat-height40 mat-input-style">
                <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                  <mat-option [value]="2">2</mat-option>
                  <mat-option [value]="25">25</mat-option>
                  <mat-option [value]="50">50</mat-option>
                  <mat-option [value]="75">75</mat-option>
                  <mat-option [value]="100">100</mat-option>
                </mat-select>
              </mat-form-field>
              <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
            </label>
            <!-- Download Icon -->
            <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
          </div>
        </ion-col>

      </ion-row>


          <div class="p-10">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="table-container">
                  <table class="custom-table rounded-header">
                     <thead>
                      <tr>
                        
                         <th *ngFor="let item of tableHeaders"
                          class="fs-14 font_bold cl-black">
                          <div class=" verticle-center justify-content-space-between icon-style">
                            {{ item?.label }}
                          </div>
                         </th>
                      </tr>
                    </thead>
                      <tbody class="bg-white">    
                          <tr *ngFor="let program of getProgramme">
                            <td>{{ program.trainingType }}</td>
                             <td>{{ program.programmeTitle }}</td>
                             <td>{{ program.programmeCode }}</td>
                             <td><a [href]="program.lmsLink" target="_blank">{{program.lmsLink}}</a></td>
                             <td>{{ program.startDate }}</td>
                             <td>{{ program.endDate }}</td>
                             <td>{{ program.startTime}}</td>
                             <td>{{ program.endTime}}</td>
                             <td>{{ program.functionalOrBehavioral }}</td>
                             <td>{{ program.department }}</td>
                             <td>{{ program.band }}</td>
                             <td>{{ program.grade }}</td>
                             <td>{{ program.location }}</td>
                             <td>{{ program.numberOfProgramDays }}</td>
                             <td><a (click)="facultyNamePopup()">{{ program.faculty?.facultyName }}</a></td>
                             <td>{{ program.objective }}</td>
                        </tr>
                      </tbody>
                  </table>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>   
      </div>





      <!-- ==================================== Team Training Calendor ==============================================-->


            <div class="p-10 m-20"   *ngIf="selectedTypeTabName=='employeeapproval'" >      
              <div class="cardBox mb-20">
                <ion-row class="ion-align-items-center ion-justify-content-start ml-20 pt-20">

                  <!-- Year Select -->
                  <ion-col size="12" size-sm="3" class=" ml-sm-20 mt-sm-20">
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                                  (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                        <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                          {{ sharedService.transformYearToFyFormat(item.year) }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                
                  <!-- Program Select -->
                  <ion-col size="12" size-sm="3" class="ml-sm-20 mt-sm-20">
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select Program" >
                        <mat-option *ngFor="let program of programList" [value]="program">
                          {{ program }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>
                </ion-row>
                
                <hr style="border: none; height: 1px; background-color: #cccccc8f;" />

          <ion-row class="ion-align-items-center ion-justify-content-between ml-10">
            <ion-col size="12" size-lg="9">
              <ion-row class="ion-align-items-center">
                <!-- Search -->
                <ion-col size="12" size-sm="4" >
                  <mat-form-field class="mat-height40 mat-input-style w-100">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                  </mat-form-field>
                </ion-col>
              </ion-row>
            </ion-col>

            <ion-col size="12" size-lg="3" >
              <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">    
                <label>
                  <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                  <mat-form-field class="w70px mat-height40 mat-input-style">
                    <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                      <mat-option [value]="2">2</mat-option>
                      <mat-option [value]="25">25</mat-option>
                      <mat-option [value]="50">50</mat-option>
                      <mat-option [value]="75">75</mat-option>
                      <mat-option [value]="100">100</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
                </label>
                <!-- Download Icon -->
                <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
              </div>
            </ion-col>

          </ion-row>

                
                <div class="p-10">
                  <ion-row>
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="table-container">
                        <table class="custom-table rounded-header">
                           <thead>
                            <tr>
                              <ng-container *ngFor="let item of tableHeaders">
                                <th *ngIf="item.label !== 'Action'" class="fs-14 font_bold cl-black">
                                  <div class="verticle-center justify-content-space-between icon-style">
                                    {{ item?.label }}
                                  </div>
                                </th>
                              </ng-container>
                            </tr>
                          </thead>
                            <tbody class="bg-white">
                              <tr *ngFor="let program of getProgramme">
                               <td>{{ program.trainingType }}</td>
                                <td>{{ program.programmeTitle }}</td>
                                <td>{{ program.programmeCode }}</td>
                                <td><a [href]="program.lmsLink" target="_blank">{{program.lmsLink}}</a></td>
                                <td>{{ program.startDate }}</td>
                                <td>{{ program.endDate }}</td>
                                <td>{{ program.startTime}}</td>
                                <td>{{ program.endTime}}</td>
                                <td>{{ program.functionalOrBehavioral }}</td>
                                <td>{{ program.department }}</td>
                                <td>{{ program.band }}</td>
                                <td>{{ program.grade }}</td>
                                <td>{{ program.location }}</td>
                                <td>{{ program.numberOfProgramDays }}</td>
                                <td><a (click)="facultyNamePopup()">{{ program.faculty?.facultyName }}</a></td>
                                <td>{{ program.objective }}</td>
                              </tr>
                            </tbody>
                        </table>
                      </div>
                      
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            
            
            
            
            
            
            
        
            <!-- =================================== HOD/Manager Nomination ============================================== -->
        
            <div class="cardBox mb-20">
            
              <ion-row class="ion-align-items-center ml-20 pt-20">

                <!-- Left Column: Present & Absent Stats -->
                <ion-col size="6" class="d-flex align-items-center">
                  <div class="nominate-pending-group d-flex align-items-center" style="gap: 10px;">
                    <span class="nominated ">Total Nominated: 100</span>
                    <span class="pending">Total Pending: 40</span>
                  </div>
                </ion-col>
              
                <!-- Right Column: Dropdowns -->
                <ion-col size="6" style="display: flex; justify-content: flex-end; gap: 15px;">
                  <!-- Year Select -->
                  <mat-form-field class="custom-mat-field mat-height40 mat-input-style m-0" appearance="fill">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                                (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                      <mat-option *ngFor="let item of pmsYears" [value]="item.year">
                        {{ sharedService.transformYearToFyFormat(item.year) }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              
                  
                  <!-- Status Dropdown -->
                  <mat-form-field class="mat-height40 mat-input-style m-0" appearance="fill">
                    <mat-select placeholder="Select Status">
                      <mat-option *ngFor="let program of statusList" [value]="program">
                        {{ program }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
  
                
              
              </ion-row>
              
              <hr style="border: none; height: 1px; background-color: #cccccc8f;"/>

                              
              <ion-row class="ion-align-items-center ion-justify-content-between ml-10">

                <!-- Left: Search & Action Buttons -->
                <ion-col size="12" size-lg="9">
                  <ion-row class="ion-align-items-center">
              
                    <!-- Search -->
                    <ion-col size="12" size-sm="4" class="mb-16">
                      <mat-form-field class="mat-height40 mat-input-style w-100">
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                      </mat-form-field>
                    </ion-col>
              
                    <!-- Approve / Reject -->
                    <ion-col size="12" size-sm="4" class="mb-16" style="display: flex; gap: 10px;" *ngIf="isAnySelected">
                      <button type="button" class="add_btnn nominate-btn" (click)="nominateSelected()">Nominate</button>
                    
                    </ion-col>
              
                  </ion-row>
                </ion-col>
              
                <!-- Right: Show Entries + Download -->
                <ion-col size="12" size-lg="3" class="mb-16">
                  <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">
                   
                    <label>
                      <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                      <mat-form-field class="w70px mat-height40 mat-input-style">
                        <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                          <mat-option [value]="2">2</mat-option>
                          <mat-option [value]="25">25</mat-option>
                          <mat-option [value]="50">50</mat-option>
                          <mat-option [value]="75">75</mat-option>
                          <mat-option [value]="100">100</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
                    </label>
              
                    <!-- Download Icon -->
                    <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
              
                  </div>
                </ion-col>
              
              </ion-row>
              
              <div class="p-10">
                <ion-row>
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="table-container">
                      
                      <table class="custom-table rounded-header">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">
                              <mat-checkbox  color="primary" (change)="selectAll($event)"></mat-checkbox>
                            </th>
                            <th *ngFor="let item of employeeTableHeaders" class="fs-14 font_bold cl-black">
                              <div class="verticle-center justify-content-space-between icon-style">
                                {{ item?.label }}
                              </div>
                            </th>
                          </tr>
                        </thead>
                    
                        <tbody class="bg-white">
                          <tr *ngFor="let program of getEmpNominate">
                            <td>
                              <mat-checkbox  color="primary" [(ngModel)]="program.selected"  (change)="updateSelectionStatus()" [disabled]="program.status !== 'PENDING'" [ngClass]="{'disableStyle':program.status !== 'PENDING'}"></mat-checkbox>
                            </td>
                    
                            <td>{{ program.employeeId }}</td>
                            <td>{{ program.userName }}</td>
                            <td>{{ program.department }}</td>
                            <td>{{ program.band }}</td>
                            <td>{{ program.grade }}</td>
                            <td> <button [ngClass]="{
                              'status-nominate': program.status === 'NOMINATED',
                              'status-approved': program.status === 'APPROVED',
                              'status-reject': program.status === 'REJECTED',
                              'status-pending': program.status === 'PENDING'
                            }"> {{ program.status }}</button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    
                  </ion-col>
                </ion-row>
              </div>
            </div>
          
          
          
          
          
          
        </div>



    </div>
 



    </div>

 
 